import React, { useEffect, useState } from "react";
import { get } from "lodash";
// import { loadState } from '../../store/LocalStorage'
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function UpdateManager(props) {
  // const history=useHistory();
  const navigate = useHistory();
  const [Emotion, setEmotion] = React.useState("");
  const [formData, setName] = useState({
    first: "",
    last: "",
    email: "",
    phone: "",
    addr: "",
    pass: "",
    org: "",
    formFile: "",
  });
  const [file, setFile] = useState();
  const mangerId = localStorage.getItem("ManegerId");
  const UserRole = localStorage.getItem("URole");

  const userid = mangerId;

  const imagepath =
    `${process.env.REACT_APP_API_URL}/GetImageById?UserId=` + userid;

  // const { IntId, Ques} = get(loadState(), "IntId") || {};
  //console.log("pass id", mangerId)
  useEffect(() => {
    LoadIntents();
  }, []);

  const LoadIntents = () => {
    const datavalue = {
      Usetid: mangerId,
    };
    // const config = {

    //     headers: { 'content-type': 'multipart/form-data' }
    // }
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getManagerById`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
      .then((res) => {
        // //console.log("get value", res);
        // "id": 3,
        // "first_Name": "Manoj ",
        // "last_Name": "ajpai",
        // "emai_Id": "manoj234@gmail.com",
        // "phone": "6547874780",
        // "role": null,
        // "u_Address": "dffdg",
        // "u_Password": "565fgf",
        // "u_Organization": "new jursi"
        //console.log("list", res.data[0])
        setName({
          first: res.data[0].first_Name,
          last: res.data[0].last_Name,
          email: res.data[0].emai_Id,
          phone: res.data[0].phone,
          addr: res.data[0].u_Address,
          pass: res.data[0].u_Password,
          org: res.data[0].u_Organization,
        });
        // setIntentList(res.data)
        // setName({ intents: res.data.result[0].Intents});
      });
  };

  const managerSubmit = async (e) => {
    e.preventDefault();

    //console.log("formData", formData)

    let formDataSet = new FormData();
    //formdata object
    if (
      formData.phone === "" ||
      formData.addr === "" ||
      formData.pass === "" ||
      formData.email == ""
    ) {
      if (formData.phone === "") {
        Swal.fire({
          title: "Error",
          text: "Phone Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } else if (formData.addr === "") {
        Swal.fire({
          title: "Error",
          text: "Address Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } else if (formData.pass === "") {
        Swal.fire({
          title: "Error",
          text: "password Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Email Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      //console.log("formData", formData.first.charAt(0).toUpperCase() + formData.first.slice(1))
      let formDataSet = new FormData();

      formDataSet.append(
        "first_Name",
        formData.first == null || formData.first == ""
          ? "0"
          : formData.first.charAt(0).toUpperCase() + formData.first.slice(1)
      ); //append the values with key, value pair
      formDataSet.append(
        "last_Name",
        formData.last == null || formData.last == ""
          ? "0"
          : formData.last.charAt(0).toUpperCase() + formData.last.slice(1)
      );
      formDataSet.append("emai_Id", formData.email);
      formDataSet.append("phone", formData.phone);
      formDataSet.append("u_Address", formData.addr);
      formDataSet.append("u_Password", formData.pass);
      formDataSet.append(
        "U_Organization",
        formData.org == null || formData.org == "" ? "0" : formData.org
      );
      // formDataSet.append('formFile', file);
      formDataSet.append("uid", mangerId);

      //console.log("formdataset", formDataSet)
      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updateUserProfile`,
        data: formDataSet,
        headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          //console.log("get value", res);

          //console.log("success")
          // setName({ intents: "", Ans1: "", Ans2: "" });
          Swal.fire({
            title: "Success",
            text: "Profile Updated Successfully",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(function () {
            // window.location.pathname = "/patient-ai/IntentList";
            // LoadUser();
            window.location.reload(true);
            // navigate.push('/');
          });
        })
        .catch((error) => {
          console.log("error occur", error);
        });
    }
  };

  const onUpload = (event) => {
    // UploadImage
    // userActions.uploadFile(token, get(event, 'target.files[0]')).then(res => {
    //console.log("upload", get(event, 'target.files[0]'))

    const imagevalue = {
      formFile: get(event, "target.files[0]"),
      usrId: mangerId,
    };
    // setFile(get(event, 'target.files[0]'))
    // //console.log("image name",file)

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/UploadImageByID`,
      data: imagevalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("save msg", res)
      // window.location.reload(true)
      // navigate.push('/');
    });
  };
  const BackFunc = () => {
    UserRole === "Admin"
      ? navigate.push("/ManagerList")
      : navigate.push("/index");
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Manager</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            {/* <div className='col-md-3'>

                      </div> */}

            <div className="col-md-12 col-sm-12">
              <div className="card card-box">
                <div className="card-head">
                  <header>Profile</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  {/* <form className="form-horizontal"> */}
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={managerSubmit}
                  >
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            First Name
                          </label>
                          <input
                            type="text"
                            value={formData.first}
                            onChange={handleChange}
                            name="first"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="First Name"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Last Name
                          </label>

                          {/* <input type="text" className="form-control" id="horizontalFormEmail"
                                                        placeholder="Last Name" /> */}
                          <input
                            type="text"
                            value={formData.last}
                            onChange={handleChange}
                            name="last"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Last Name"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            name="email"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Email"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Phone no.
                          </label>
                          <input
                            type="number"
                            value={formData.phone}
                            onChange={handleChange}
                            name="phone"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Phone No."
                          />
                        </div>
                        {/* <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Password
                          </label>
                          <input
                            type="text"
                            value={formData.pass}
                            onChange={handleChange}
                            name="pass"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Password"
                          />
                        </div> */}
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className=" control-label"
                          >
                            Organization
                          </label>

                          <input
                            type="text"
                            value={formData.org}
                            onChange={handleChange}
                            name="org"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Organizattion"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormPassword"
                            className="col-sm-2 control-label"
                          >
                            Address
                          </label>
                          <textarea
                            type="text"
                            value={formData.addr}
                            onChange={handleChange}
                            name="addr"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Adress"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormPassword"
                            className="col-sm-2 control-label"
                          >
                            Password
                          </label>
                          <textarea
                            type="text"
                            value={formData.pass}
                            onChange={handleChange}
                            name="pass"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Password"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormPassword"
                            className="col-12 control-label"
                          >
                            User Image
                          </label>
                          <div className="col-12">
                            <div className="row">
                              <div className="col-2">
                                <img
                                  src={imagepath}
                                  style={{ width: "50px" }}
                                  alt="new"
                                />
                              </div>
                              <div className="col-10">
                                <div
                                  className="photoEdit mt-3"
                                  style={{ position: "relative" }}
                                >
                                  <input
                                    type="file"
                                    onChange={onUpload}
                                    id="myFile"
                                    name="formFile"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <button
                            type="submit"
                            className="btn btn-info m-r-20 d-inline-block mt-4"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="offset-md-3 col-md-9">
                        <div className="col-12 text-end">
                          {/* <button type="button" className="btn btn-default d-inline-block" onClick={canclebtn}>Cancel</button> */}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateManager;
